import { Banner } from '@sunwebgroup/uds-ui/banner'
import styles from './OverlayBanner.module.css'

interface OverlayBannerProps {
  color: 'success' | 'danger'
  message: string
}

export function OverlayBanner({ color, message }: OverlayBannerProps) {
  return (
    <div className={styles.container}>
      <Banner
        className={styles.banner}
        color={color}
        size="M"
        hasIcon
        display="overlay"
        contentIsCentered
      >
        <Banner.TextsWrapper>
          <Banner.Text>{message}</Banner.Text>
        </Banner.TextsWrapper>
      </Banner>
    </div>
  )
}
